import { Country } from 'country-code-lookup';

export const getCountryDisplayName = (country: Country): string =>
	`${country.iso2} (${country.country})`;
